<template>
    <div>
        <packet-choice-component :packet_type="'upgrade'" @selectPacket="selectPacket" @no_packet="noPacketAlert"/>
        <div class="pt-3 pb-3">
            <button class="btn btn-danger float-left"  @click="goBack">
                {{$t('intern_packete_upgrade.text_cancel')}}
            </button>
            <button class="btn btn-success float-right" :disabled="!packet" @click="upgradePacket">
                {{$t('intern_packete_upgrade.text_us')}}
            </button>
        </div>
    </div>
</template>

<script>
    import PacketChoiceComponent from '../../components/object/booking/PacketChoiceTab';

    export default {
        data() {
            return {
                packet: null
            }
        },
        components: {
            PacketChoiceComponent
        },
        methods: {
            goBack(){
              this.$router.push({name: 'inserat-uebersicht', params: {page: 1}});
            },
            noPacketAlert() {
                let h = this.$createElement;
                let msgNode = h('div', { domProps: {innerHTML: this.$t('intern_objekte_list.nopacket_gewerblich_dialog_text')}});

                this.$bvModal.msgBoxOk([msgNode], {
                    title: 'Benachrichtigung',
                    okVariant: 'success',
                    okTitle: 'ok',
                }).then(val => {
                    this.$router.push('/');
                });
            },
            selectPacket(packet) {
                this.packet = packet;
            },
            upgradePacket() {
                this.$store.state.loading = true;
                this.$http.put('/userPacketApi/upgradePacket?packet_id=' + this.packet).then( response => {
                    this.$bvToast.toast(response.data, {
                        variant: 'success',
                        title: 'Benachrichtigung'
                    });

                    setTimeout(() => {
                        this.$router.push('/');
                    }, 1000);

                }).catch( error => {
                    this.$bvToast.toast(error.response.data.data, {
                        variant: 'danger',
                        title: 'Fehlermeldung'
                    });
                }).then(() => {
                    this.$store.state.loading = false;
                });
            }
        },
        created() {
            document.title = 'Pakete upgraden';
        }
    }
</script>

<style scoped>

</style>
